import {
    GET_OVERVIEW_SUCCESS,
    FETCH_INVOICES_STARTED,
    ADD_INVOICE_FAILED,
    ADD_INVOICE_SUCCEEDED,
    RESET_ADD_INVOICE_STATE,
    FETCH_INVOICES_SUCCEEDED,
    SEND_INVOICE_SUCCEEDED,
    SEND_INVOICE_FAILED,
    RESET_SEND_INVOICE_STATE,
    SEARCH_INVOICES_STARTED,
    SEARCH_INVOICES_SUCCEEDED,
    SEARCH_INVOICES_FAILED,
    RESET_SEARCH_INVOICES,
    RESET_INVOICES,
    FETCH_SINGLE_INVOICE_STARTED,
    FETCH_SINGLE_INVOICE_SUCCESS,
    FETCH_SINGLE_INVOICE_FAILED,
    UPDATE_INVOICE_SUCCEEDED,
    UPDATE_INVOICE_FAILED,
    RESET_UPDATE_INVOICE_STATE,
    GET_OVERVIEW_DATE_RANGE_SUCCESS,
    GET_OVERVIEW_DATE_RANGE_FAILED,
    GET_OVERVIEW_DATE_RANGE_LOADING,
    FETCH_INVOICES_FAILED,
    GET_INVOICE_STATUS_STARTED,
    GET_INVOICE_STATUS_SUCCEEDED,
    GET_INVOICE_STATUS_FAILED,
} from "../actions/types/invoice.types";

const initialState = {
    invoiceToBeEdited: {},
    invoices: null,
    initialInvoices: [],
    // invoiceOverview: [
    //     {
    //         label: "paid invoices",
    //         amount: 0,
    //         total: 0,
    //     },
    //     {
    //         label: "overdue invoices",
    //         amount: 0,
    //         total: 0,
    //     },
    //     {
    //         label: "invoices due in 30 days",
    //         amount: 0,
    //         total: 0,
    //     },
    //     // {
    //     //     label: "Draft",
    //     //     amount: 0,
    //     // },
    // ],
    invoiceOverview: null,
    invoiceOverviewDateRange: {
        totalReceivedPayment: 0,
        totalDuePayment: 0,
        totalPendingPayment: 0,
        totalDraftPayment: 0,
    },
    invoiceOverviewDateRangeLoading: false,
    fetchInvoicesState: "idle",
    fetchInvoiceToBeEditedState: "loading",
    addInvoiceState: "idle",
    updateInvoiceState: "idle",
    sendInvoiceState: "idle",
    searchInvoiceByFilterState: "idle",
    invoiceErrorMessage: "",
    invoiceDetails: null,
    singleInvoiceState: "idle",
    invoiceStatus: null,
    invoiceStatusState: "idle",
};

const invoiceReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case FETCH_INVOICES_STARTED:
            return {
                ...state,
                fetchInvoicesState: "loading",
            };

        case FETCH_INVOICES_SUCCEEDED: {
            const data = Array.isArray(payload) ? payload : [];

            return {
                ...state,
                fetchInvoicesState: "success",
                invoices: [...data],
                initialInvoices: [...data],
            };
        }
        case FETCH_INVOICES_FAILED:
            return {
                ...state,
                fetchInvoicesState: "failed",
            };
        case GET_OVERVIEW_SUCCESS: {
            const { data } = payload;

            return {
                ...state,
                invoiceOverview: data,

                //     [
                //     {
                //         label: "paid invoices",
                //         amount: data.totalReceivedPayment,
                //         total: 0,
                //     },
                //     {
                //         label: "overdue invoices",
                //         amount: data.totalDuePayment,
                //         total: 0,
                //     },
                //     {
                //         label: "invoices due in 30 days",
                //         amount: data.totalPendingPayment,
                //         total: 0,
                //     },
                // ],
            };
        }

        case GET_OVERVIEW_DATE_RANGE_SUCCESS: {
            return {
                ...state,
                invoiceOverviewDateRange: payload,
                invoiceOverviewDateRangeLoading: false,
            };
        }

        case GET_OVERVIEW_DATE_RANGE_LOADING: {
            return {
                ...state,
                invoiceOverviewDateRangeLoading: true,
            };
        }

        case GET_OVERVIEW_DATE_RANGE_FAILED: {
            return {
                ...state,
                invoiceOverviewDateRangeLoading: false,
            };
        }

        case ADD_INVOICE_SUCCEEDED: {
            return {
                ...state,
                addInvoiceState: "success",
            };
        }

        case ADD_INVOICE_FAILED: {
            return {
                ...state,
                addInvoiceState: "failed",
                invoiceErrorMessage: payload,
            };
        }

        case RESET_ADD_INVOICE_STATE: {
            return {
                ...state,
                addInvoiceState: "idle",
            };
        }

        case UPDATE_INVOICE_SUCCEEDED: {
            return {
                ...state,
                updateInvoiceState: "success",
            };
        }

        case UPDATE_INVOICE_FAILED: {
            return {
                ...state,
                updateInvoiceState: "failed",
                invoiceErrorMessage: payload,
            };
        }

        case RESET_UPDATE_INVOICE_STATE: {
            return {
                ...state,
                updateInvoiceState: "idle",
            };
        }

        case SEND_INVOICE_SUCCEEDED: {
            return {
                ...state,
                sendInvoiceState: "success",
            };
        }

        case SEND_INVOICE_FAILED: {
            return {
                ...state,
                sendInvoiceState: "failed",
                invoiceErrorMessage: payload,
            };
        }

        case RESET_SEND_INVOICE_STATE: {
            return {
                ...state,
                sendInvoiceState: "idle",
            };
        }

        case SEARCH_INVOICES_STARTED:
            return {
                ...state,
                searchInvoiceByFilterState: "loading",
            };

        case SEARCH_INVOICES_FAILED:
            return {
                ...state,
                searchInvoiceByFilterState: "failed",
            };

        case SEARCH_INVOICES_SUCCEEDED: {
            const data = Array.isArray(payload.data) ? payload.data : [];

            return {
                ...state,
                searchInvoiceByFilterState: "success",
                invoices: [...data],
            };
        }

        case RESET_SEARCH_INVOICES:
            return {
                ...state,
                searchInvoiceByFilterState: "idle",
            };

        case RESET_INVOICES:
            return {
                ...state,
                invoices: state.initialInvoices,
            };

        case FETCH_SINGLE_INVOICE_STARTED:
            return {
                ...state,
                fetchInvoiceToBeEditedState: "loading",
                singleInvoiceState: "loading",
            };

        case FETCH_SINGLE_INVOICE_SUCCESS:
            return {
                ...state,
                singleInvoiceState: "success",
                invoiceDetails: payload,
            };

        case FETCH_SINGLE_INVOICE_FAILED:
            return {
                ...state,
                fetchInvoiceToBeEditedState: "failed",
                singleInvoiceState: "failed",
            };
        case GET_INVOICE_STATUS_STARTED:
            return {
                ...state,
                invoiceStatusState: "loading",
            };
        case GET_INVOICE_STATUS_SUCCEEDED:
            return {
                ...state,
                invoiceStatusState: "success",
                invoiceStatus: payload,
            };
        case GET_INVOICE_STATUS_FAILED:
            return {
                ...state,
                invoiceStatusState: "failed",
            };
        default:
            return state;
    }
};

export { invoiceReducer };
